import {
  HierarchyContextProps,
  IHierarchyActionLoadHierarchy,
  IHierarchyActionSaveHierarchyCompleted,
  LOAD_HIERARCHY,
} from "../interface";
import { hcr_loadHierarchy } from "./hcr_loadHierarchy";

/**
 * Normalises state after a successful hierarchy save.
 * TODO: Remove this, migrate functionality into APP_SAVE_COMPLETED
 *
 * @param state - The current hierarchy context state.
 * @param action - The save-hierarchy-completed action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_saveHierarchyCompleted = (
  state: HierarchyContextProps,
  action: IHierarchyActionSaveHierarchyCompleted,
): HierarchyContextProps => {
  const filteredHierarchyNodes = [
    ...state.hierarchyNodes
      .filter((hn) => hn.id !== action.hierarchy.id && hn.id !== action.oldHierarchyId)
      .map((hn) => {
        if (action.oldHierarchyId && hn.id === action.hierarchy.parentId) {
          return {
            ...hn,
            children: [
              ...hn.children.filter((cid) => cid.id !== action.oldHierarchyId),
              {
                id: action.hierarchy.id,
                hierarchyTag: hn.hierarchyTag,
                level: hn.level,
                name: action.hierarchy.name,
                parentTag: hn.parentTag,
                type: hn.type,
                tocMajorVersion: action.hierarchy.tocMajorVersion,
                tocMinorVersion: action.hierarchy.tocMinorVersion,
              },
            ],
          };
        }

        return hn;
      }),
    action.hierarchy,
  ];

  const loadLikeAction: IHierarchyActionLoadHierarchy = {
    operation: LOAD_HIERARCHY,
    hierarchy: action.hierarchy,
    hierarchyNodes: [],
    accessRights: state.accessRights,
    isSubscribed: state.isSubscribed,
  };

  const loadedState = hcr_loadHierarchy(
    {
      ...state,
      hierarchyNodes: filteredHierarchyNodes,
    },
    loadLikeAction,
  );

  return {
    ...loadedState,
    isNameChanged: false,
    doTocSave: false,
    hierarchyNodes: filteredHierarchyNodes,
  };
};
